import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Pirma_Title } from '../../../../../utils/EN/Modals/SpotsModals';

const ModalGallos = () => {
  return (
    <>
      <ModalVideo
        id="spot-gallos"
        dataText={Pirma_Title}
        videoSrc="https://player.vimeo.com/video/125490257?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_GALLOS"
      />
    </>
  );
};

export default ModalGallos;
